import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import hasFeature from 'modules/core/lib/hasFeature'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import CollectionsBootstrap from 'modules/one_on_ones/lib/CollectionsBootstrap'

const Container = () => {
  const session = useCurrentSession()

  return (
    <AuthorizeUser authorizeFn={() => hasFeature('one_on_ones') && !!session.employee}>
      <Outlet
        context={{
          loading: false,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
